// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function callConfigFunction(functionDefinition, functionName, argumentNames, ...argumentValues) {
    let functionBody;
    switch (typeof functionDefinition) {
        case 'function':
            functionBody = functionDefinition;
            break;
        case 'string':
            try {
                functionBody = Function('"use strict"; return (function(' + argumentNames + ') { ' + functionDefinition + '; })')();
            }
            catch (error) {
                console.error('Invalid ' + functionName + ' function', error);
            }
            break;
    }
    if (functionBody) {
        try {
            return functionBody(...argumentValues);
        }
        catch (error) {
            console.error('Error in ' + functionName + ' function', error);
        }
    }
    return undefined;
}
